<template>
  <v-layout align-center column>
    <div class="container">
      <div class="loading-group" v-if="status === ''">
        <div class="loader"></div>
        <div>Harap Tunggu...</div>  
      </div>

      <div class="success-group" v-if="status === 'success'">
        <div class="figure">
          <img class="img" src="https://cdn.dompetkilat.id/company-profile/email/static/images/success-verify-lender.png" alt="Success"/>
        </div>
        <div>
          <h1 class="heading">Yoohoo! Verifikasi Email Berhasil</h1>
          <p class="mb16">Verifikasi email anda berhasil. Silakan masuk ke aplikasi Lender menggunakan email terdaftar untuk melakukan pendanaan.</p>
          <p class="mb16">Jangan berikan informasi ini pada siapapun, bahkan yang mengaku dari pihak Dompet Kilat!</p>
          <p class="mb36">Jika ada pertanyaan, silahkan hubungi tim kami di <a class="link" href="mailto:cs@dompetkilat.co.id">cs@dompetkilat.co.id</a></p>
          <p class="mb0">Regards,</p> 
          <p>
            <strong>Tim Dompet Kilat</strong>
          </p> 
        </div>
      </div>

      <div class="failed-group" v-if="status === 'failed'">
        <div class="figure">
          <img class="img" src="https://cdn.dompetkilat.id/company-profile/email/static/images/failed-verify-lender.png" alt="Failed"/>
        </div>
        <div>
          <h1 class="heading">Coba Lagi...</h1>
          <p class="mb16">Verifikasi Email anda gagal. Silakan lakukan verifikasi kembali pada email yang telah kami kirimkan.</p>
          <p class="mb16">Jangan berikan informasi ini pada siapapun, bahkan yang mengaku dari pihak Dompet Kilat!</p>
          <p class="mb36">Jika ada pertanyaan, silahkan hubungi tim kami di <a class="link" href="mailto:cs@dompetkilat.co.id">cs@dompetkilat.co.id</a></p>
          <p class="mb0">Regards,</p> 
          <p>
            <strong>Tim Dompet Kilat</strong>
          </p> 
        </div>
      </div>
    </div>
  </v-layout>
</template>
<script>
import axios from "axios";

export default {
  components: {},
  data() {
    return {
      status: this.$route?.query?.status || '',
    };
  },
  mounted: function() {
    if (this.$route?.query?.token) {
      this.verifyEmail();
    }
  },
  methods: {
    async verifyEmail() {
      try {
        const response = await axios({
          method: "post",
          url: process.env.VUE_APP_VERIFY_EMAIL,
          data: {
            userIdentifier : this.$route?.query?.userIdentifier,
            token: this.$route?.query?.token
          },
        });

        if (response.data.status === process.env.VUE_APP_STATUS_VERIFY_EMAIL) {
          window.location.href = '/lender/verify-email?status=success';
        } else {
          window.location.href = '/lender/verify-email?status=failed';
        }
      } catch(error) {
        window.location.href = '/lender/verify-email?status=failed';
      }
    },
  }
};
</script>
<style scoped>
html,
body {
  width: 100%;
  overflow-x: hidden;
}

.mb0 {
    margin-bottom: 0px;
}

.mb16 {
  margin-bottom: 16px;
}

.mb36 {
  margin-bottom: 36px;
}

.container {
  display: flex;
  align-items: center;
  padding: 80px 16px;
  flex-direction: column;
}

.success-group, .failed-group {
  display: flex;
  align-items: center;
}

.heading {
  text-align: left;
  margin-left: 0;
  margin-right: 0;
}

.link {
  color: #D3352C;
}

.figure {
  text-align: center;
  padding: 48px 60px;
  max-width: 700px;
}

.img {
  width: 100%;
  height: auto;
  object-fit: contain;
}

.loading-group {
  padding: 100px 0 50px;
  text-align: center;
}

.loader {
  margin: 24px 0;
  border: 10px solid #f3f3f3;
  border-radius: 50%;
  border-top: 10px solid #9D0005;
  width: 120px;
  height: 120px;
  -webkit-animation: spin 2s linear infinite; /* Safari */
  animation: spin 2s linear infinite;
}

/* Safari */
@-webkit-keyframes spin {
  0% { -webkit-transform: rotate(0deg); }
  100% { -webkit-transform: rotate(360deg); }
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}
</style>
